export class AdminReviewerBookEditRequest {
  idBookVersion: number;
  isbn: string | null;
  doi: string | null;
  totalPages: number | null;
  frontCoverFileName: string | null = null;
  backCoverFileName: string | null = null;

  coverForPrintFileName: string | null = null;
  bookForPrintFileName: string | null = null;
  bookForEbookFileName: string | null = null;
  reason?: string | null;
}
